import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

const Rfail = (props) => {
  const { apiUrl, history } = props;
  let orderCode = new URL(window.location.href).searchParams.get('orderId');
  let code = new URL(window.location.href).searchParams.get('code');
  let message = new URL(window.location.href).searchParams.get('message');

  const _callApi = async () => {
    const result = await axios.post(apiUrl + '/collaboReserveError', {
      orderCode,
      code,
      message,
    });

    const intReturn = result.data[0].intReturn;

    // if (intReturn === 0) {
    alert(`결제도중 오류가 발생했습니다.\n${message}`);
    history.push('/cr');
    // }
  };

  useEffect(() => {
    _callApi();
  }, []);

  return <div style={{ color: '#fff' }}>{message}</div>;
};

export default shopContext(withRouter(Rfail));
